import React from "react";
import { Link } from "react-router-dom";

const CATEGORIES = [
  { title: "Getting started", items: ["Creating an account","AI health navigator","Booking a consultation","Payments and refunds"] },
  { title: "During a consultation", items: ["Pre-check for video","Sharing documents","Speaking to your doctor","After the consultation"] },
  { title: "Care Passport", items: ["Understanding your records","Exporting your data","Follow-ups","Medications and prescriptions"] },
  { title: "Account & billing", items: ["Change my email","Delete my account","Invoices","Cancellation policy"] },
];

export default function HelpCentre() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">Help Centre</div>
        <h1 className="cm-h2">We're here to help.</h1>
        <p className="cm-body mt-3">Browse categories, or <Link to="/contact" className="text-[#4a90d9] font-semibold">contact us</Link> to open a ticket.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-2 gap-6">
        {CATEGORIES.map((c, i) => (
          <div key={c.title} className="cm-card" data-testid={`help-cat-${i}`}>
            <h3 className="font-semibold text-[#1a2b4a] mb-3">{c.title}</h3>
            <ul className="space-y-2 text-sm">
              {c.items.map(it => <li key={it}><a className="text-[#475569] hover:text-[#4a90d9]" href="#">{it}</a></li>)}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
